import { setup } from 'bem-cn'
import isSameDay from 'date-fns/is_same_day'
import React, { Component } from 'react'
import { DropTarget } from 'react-dnd'
import { connect } from 'react-redux'
import { ItemTypes } from '../../constants'
import { setCurrentTaskDates } from '../../store/actions'
import { calculateNewDates } from '../../utils'

const block = setup({
    mod: '--'
})

const b = block('Day')
//Stupid optimization, without prevDate disptach will be cleed every millisecond
let prevDate = null
const dayTarget = {
    drop(props) {
        prevDate = null
        return {
            date: props.date
        }
    },

    hover(props, monitor) {
        const taskInfo = monitor.getItem()
        if (taskInfo && !isSameDay(prevDate, props.date)) {
            prevDate = props.date
            const newDates = calculateNewDates(
                taskInfo.type,
                props.date,
                taskInfo.startDate,
                taskInfo.endDate,
                taskInfo.moveDate,
                taskInfo.duration
            )
            props.dispatch(setCurrentTaskDates((taskInfo.type === 'move' ? 'move' : 'resize'), newDates.startDate, newDates.endDate))
        }
    }
}

function collect(connect, monitor) {
    return {
        connectDropTarget: connect.dropTarget(),
        isOver: monitor.isOver()
    }
}

class Day extends Component {
    isToday = () => {
        const today = new Date()
        return (
            this.props.date.getFullYear() === today.getFullYear() &&
            this.props.date.getMonth() === today.getMonth() &&
            this.props.date.getDate() === today.getDate()
        )
    }

    render() {
        const { date, active, height, connectDropTarget } = this.props

        return (
            <div
                className={b({ inactive: !active, today: this.isToday() })}
                style={{ height: height === 0 ? 'auto' : height + 'px' }}
            >
                <div className={b('day-num')}>{date.getDate()}</div>

                {this.props.children}
                {connectDropTarget(<div className={b('drop-overlay')} />)}
            </div>
        )
    }
}

export default connect()(DropTarget(ItemTypes.HANDLE, dayTarget, collect)(Day))
